export const availableDateSettings = state => state.getIn(['availableDateSettings', 'entities']);
export const availableDateSettingById = (state, id) => availableDateSettings(state).get(String(id));
export const availableDateSettingsByIds = (state, ids) =>
  ids.map(id => availableDateSettingById(state, id));
